<template>
  <v-dialog v-model="dialog" width="650">
    <template v-slot:activator="{ on }">
      <v-btn x-small v-on="on">
        {{ aggregationButtonTitle }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ $t("aggregation.select") }}
      </v-card-title>
      <v-card-text>
        <div class="d-flex flex-column">
          <h3>
            {{ $t("aggregation.applyToAllSeries") }}
          </h3>

          <div class="d-flex justify-space align-start mt-2">
            <v-select
              :items="aggregationTypes"
              :label="$t('aggregation.typeSelectLabel')"
              dense
              outlined
              class="mr-1"
              @change="masterChangeType"
            ></v-select>

            <v-select
              :items="aggregationWindows"
              :label="$t('aggregation.windowSizeSelectLabel')"
              dense
              outlined
              class="ml-1"
              @change="masterChangeWindow"
            ></v-select>
          </div>
        </div>

        <div
          v-for="(s, index) in series"
          :key="index"
          class="d-flex flex-column"
        >
          <h3>
            {{ s.name }}
          </h3>
          <div class="d-flex justify-space align-start mt-2">
            <v-select
              :items="aggregationTypes"
              :value="localValue[s.slotId]?.types[0] ?? 'last'"
              @input="(val) => (localValue[s.slotId].types = [val])"
              :label="$t('aggregation.typeSelectLabel')"
              dense
              outlined
              class="mr-1"
            ></v-select>

            <v-select
              :items="aggregationWindows"
              :value="localValue[s.slotId]?.windowSize ?? 'auto'"
              @input="(val) => (localValue[s.slotId].windowSize = val)"
              :label="$t('aggregation.windowSizeSelectLabel')"
              dense
              outlined
              class="ml-1"
            ></v-select>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="dialog = false">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn text color="primary" @click="save">
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { aggregationTypes, windowSizes } from "@/_helpers/aggregationHelper";

export default {
  name: "ChartAggregationForm",

  props: {
    series: {
      type: Array,
    },

    value: {
      type: Object,
    },
  },

  emits: ["input"],

  model: {
    prop: "value",
  },

  data() {
    return {
      localValue: this.value,
      dialog: false,
    };
  },

  computed: {
    aggregationButtonTitle() {
      if (Object.keys(this.value).length === 0)
        return this.$t("aggregation.select");

      let w = "";
      let func = "";
      for (var k of Object.keys(this.value)) {
        if (w === "") w = this.value[k]?.windowSize;
        if (func === "")
          func = this.$t(
            `aggregation.types.${this.value[k]?.types[0] ?? "last"}`
          );

        // If it is different window sizes we set to ""
        // If it is any difference in function we set to "mixed"
        if (w !== this.value[k]?.windowSize) w = "";
        if (
          func !==
          this.$t(`aggregation.types.${this.value[k]?.types[0] ?? "last"}`)
        )
          func = this.$t("aggregation.mixedTypes");
      }

      return w + " " + func;
    },

    aggregationTypes() {
      return aggregationTypes.map((at) => ({
        text: this.$t(`aggregation.types.${at}`),
        value: at,
      }));
    },

    aggregationWindows() {
      return windowSizes.map((ws) => ({
        text: ws,
        value: ws,
      }));
    },
  },

  methods: {
    save() {
      this.$emit("input", this.localValue);
      this.$emit("change", this.localValue);
      this.dialog = false;
    },

    setLocalValue() {
      if (Object.keys(this.value).length === 0) {
        // Set defaults for each series
        // TODO: Make the time smarter to check the data range for the series to figureout windowsize
        let temp = {};
        for (let s of this.series) {
          temp[s.slotId] = {
            types: ["last"],
            windowSize: "auto",
          };
        }

        this.localValue = temp;
        this.$emit("input", this.localValue);
        this.$emit("change", this.localValue);

        return;
      }

      this.localValue = this.value;
    },
    masterChangeWindow(v) {
      for (let s of this.series) {
        this.localValue[s.slotId].windowSize = v;
      }
    },

    masterChangeType(v) {
      for (let s of this.series) {
        this.localValue[s.slotId].types = [v];
      }
    },
  },

  created() {
    this.setLocalValue();
  },

  watch: {
    value() {
      this.setLocalValue();
    },
  },
};
</script>
